import React from "react";
import "./destacado-afiliarse.scss";
import GlobalContext from "../../../contexts/globalContext";
import { GatsbyImage } from "gatsby-plugin-image";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
import { navigate } from "gatsby";

const FeaturedJoin = (props: ReferenciaContenido) => {
  const {
    imagenPrincipal,
    tituloGeneral,
    tituloBoton,
    descripcion,
    redireccionBoton,
  } = props;

  return (
    <GlobalContext.Consumer>
      {(data) => (
        <div className="m-featured-join">
          <div className="m-featured-join__container">
            <div className="m-featured-join__container__img-desktop m-featured-join-hide-on-mobile-custom">
              <GatsbyImage
                className="m-featured-join__container__img-desktop"
                image={imagenPrincipal && imagenPrincipal?.gatsbyImageData}
                alt={
                  imagenPrincipal && imagenPrincipal?.title
                    ? imagenPrincipal?.title
                    : "Destacado principal"
                }
              />
            </div>

            <div className="m-featured-join__container__join">
              <div className="m-featured-join__container__join__text">
                <h2>{tituloGeneral}</h2>
                <p>
                  {descripcion &&
                    JSON.parse(descripcion?.raw)?.content[0]?.content[0]?.value}
                </p>
              </div>

              {
                <Button
                  text={tituloBoton}
                  classname={
                    "a-button  secondary m-featured-join__container__join__btn"
                  }
                  type={"button"}
                  isDisabled={false}
                  strictCss={false}
                  gtmMark={"gtmRedDeAmorServicioComienzaAhora"}
                  onClickAction={
                    data.gigyaContext.gigyaAccount
                      ? () => {
                          localStorage.setItem(
                            "selected-service-id",
                            "5fe25114e36db435fb7d9806"
                          );
                          navigate(redireccionBoton);
                        }
                      : data.gigyaContext.login
                  }
                />
              }
            </div>
          </div>
        </div>
      )}
    </GlobalContext.Consumer>
  );
};

export default FeaturedJoin;
